export function initConversationsPage () {
  if (!window.$) return

  const container = document.querySelector('.conversation-view')
  if (!container) return

  // Spinner when clicking a conversation
  window.$('.message-cell-container')
    .off('click.conversations')
    .on('click.conversations', function () {
      window.$('.loading-spinner').show()
      window.$('.message-select').addClass('darken-overlay')
    })

  // Collapse behavior
  window.$('.fa-caret-right')
    .off('click.conversations')
    .on('click.conversations', function () {
      window.$('.conversation-description').hide()
      window.$('#conversation_description').html('')
      window.$('.fa-caret-right').hide().attr('style', 'transform: translate(-15px, 8px);')
      window.$('.message-select').toggleClass('shift-right').removeClass('darken-overlay')
    })

  // Highlight navigation
  if (typeof window.navigationLink === 'function') {
    window.navigationLink('nav-inbox')
  }

  // Auto-load conversation if param exists
  const conversationId = container.dataset.conversationId
  if (conversationId) {
    window.$.ajax({ url: `/conversations/${conversationId}` })
  }

  // Auto-load system inbox if param exists
  const messageType = container.dataset.messageType
  if (messageType) {
    window.$.ajax({ url: `/messages?t=${encodeURIComponent(messageType)}` })
  }
}
